import React from 'react';
import styles from './StepTitle.module.css';

const StepTitle: React.FunctionComponent = props => (
  <h5 className={styles.root}>{props.children}</h5>
);

export default StepTitle;
